export const MODALS = {
    AUTH_CLOSE_CONFIRMATION: {
        closeOnRouteChange: false,
        name: 'AUTH_CLOSE_CONFIRMATION',
    },
    PROFILE_PHONE_CHANGE_CLOSE_CONFIRMATION: {
        closeOnRouteChange: true,
        name: 'PROFILE_PHONE_CHANGE_CLOSE_CONFIRMATION',
    },
    IMAGE_UPLOAD_ERROR_MODAL: {
        closeOnRouteChange: true,
        name: 'IMAGE_UPLOAD_ERROR_MODAL',
    },
    AGE_CONFIRM: {
        closeOnRouteChange: false,
        name: 'AGE_CONFIRM',
    },
    AUTH_CONF_SENT: {
        closeOnRouteChange: true,
        name: 'AUTH_CONF_SENT',
    },
    AUTH_DIALOG: {
        closeOnRouteChange: true,
        name: 'AUTH_DIALOG',
    },
    AUTH_REGISTRATION: {
        closeOnRouteChange: true,
        name: 'REGISTRATION',
    },
    AVAILABILITIES_TOOLTIP: {
        closeOnRouteChange: true,
        name: ' AVAILABILITIES_TOOLTIP',
    },
    BARCODE_SCANNER: {
        closeOnRouteChange: true,
        name: 'BARCODE_SCANNER',
    },
    BARCODE_SCANNER_INFO: {
        closeOnRouteChange: true,
        name: 'BARCODE_SCANNER_INFO',
    },
    BOOKING_PRODUCT: {
        closeOnRouteChange: true,
        name: 'BOOKING_PRODUCT',
    },
    BRAND_X_MODAL: {
        closeOnRouteChange: true,
        name: 'BRAND_X_MODAL',
    },
    CALCULATOR: {
        closeOnRouteChange: true,
        name: 'CALCULATOR',
    },
    CAMERA_NOT_ALLOWED: {
        closeOnRouteChange: true,
        name: 'CAMERA_NOT_ALLOWED',
    },
    CART_ANALOGS: {
        closeOnRouteChange: true,
        name: 'CART_ANALOGS',
    },
    CART_DELIVERY_FEATURES: {
        closeOnRouteChange: true,
        name: 'CART_DELIVERY_FEATURES',
    },
    CART_DELIVERY_SHARE: {
        closeOnRouteChange: true,
        name: 'CART_DELIVERY_SHARE',
    },
    CART_REMOVE: {
        closeOnRouteChange: true,
        name: 'CART_REMOVE',
    },
    CART_SHARING: {
        closeOnRouteChange: true,
        name: 'CART_SHARING',
    },
    CART_USER_ACTIONS: {
        closeOnRouteChange: true,
        name: 'CART_USER_ACTIONS',
    },
    CATALOG_MENU: {
        closeOnRouteChange: true,
        name: 'CATALOG_MENU',
    },
    CHANGE_PHONE: {
        closeOnRouteChange: true,
        name: 'CHANGE_PHONE',
    },
    CITY_CHANGE_CONFIRM: {
        closeOnRouteChange: true,
        name: 'CITY_CHANGE_CONFIRM',
    },
    CITY_CHANGE_NEW: {
        closeOnRouteChange: true,
        name: 'CITY_CHANGE_NEW',
    },
    CITY_CHOOSE: {
        closeOnRouteChange: true,
        name: 'CITY_CHOOSE',
    },
    CITY_CLARIFICATION: {
        closeOnRouteChange: false,
        name: 'CITY_CLARIFICATION',
    },
    COOL_DRINKS: {
        closeOnRouteChange: false,
        name: 'COOL_DRINKS',
    },
    CREATE_PRODUCT_REVIEW: {
        closeOnRouteChange: false,
        name: 'CREATE_PRODUCT_REVIEW',
    },
    DASHBOARD_ADD_EMAIL: {
        closeOnRouteChange: true,
        name: 'DASHBOARD_ADD_EMAIL',
    },
    DASHBOARD_CHANGE_EMAIL: {
        closeOnRouteChange: true,
        name: 'DASHBOARD_CHANGE_EMAIL',
    },
    DELIVERY_TOOLTIP: {
        closeOnRouteChange: true,
        name: 'DELIVERY_TOOLTIP',
    },
    DEGUSTATION_MEDIA_SLIDER: {
        closeOnRouteChange: true,
        name: 'DEGUSTATION_MEDIA_SLIDER',
    },
    EMAIL_RECEIPT: {
        closeOnRouteChange: true,
        name: 'EMAIL_RECEIPT',
    },
    EVENT_HALL_INFO: {
        closeOnRouteChange: true,
        name: 'EVENT_HALL_INFO',
    },
    EXPRESS_ORDER: {
        closeOnRouteChange: true,
        name: 'EXPRESS_ORDER',
    },
    EXPRESS_ORDER_POPUP: {
        closeOnRouteChange: true,
        name: 'EXPRESS_ORDER_POPUP',
    },
    FILTER_MODAL: {
        closeOnRouteChange: true,
        name: 'FILTER_MODAL',
    },
    FILTER_MODAL_MOBILE: {
        closeOnRouteChange: false,
        name: 'FILTER_MODAL_MOBILE',
    },
    FILTER_TOOLTIP: {
        closeOnRouteChange: true,
        name: 'FILTER_TOOLTIP',
    },
    GIFT_MODAL: {
        closeOnRouteChange: false,
        name: 'GIFT_MODAL',
    },
    INDIVIDUAL_TASTING: {
        closeOnRouteChange: true,
        name: 'INDIVIDUAL_TASTING',
    },
    TASTING_SUCCESS: {
        closeOnRouteChange: true,
        name: 'TASTING_SUCCESS',
    },
    INIT: {
        closeOnRouteChange: true,
        name: 'INIT',
    },
    MAIN_GALLERY: {
        closeOnRouteChange: true,
        name: 'MAIN_GALLERY',
    },
    ORDER_ADDRESS_SCHEDULE: {
        closeOnRouteChange: true,
        name: 'ORDER_ADDRESS_SCHEDULE',
    },
    ORDER_STRUCTURE: {
        closeOnRouteChange: true,
        name: 'ORDER_STRUCTURE',
    },
    OUT_OF_STOCK: {
        closeOnRouteChange: true,
        name: 'OUT_OF_STOCK',
    },
    PASSWORD_CREATE: {
        closeOnRouteChange: true,
        name: 'PASSWORD_CREATE',
    },
    PRODUCT_AVAILABILITY_INFO: {
        closeOnRouteChange: true,
        name: 'PRODUCT_AVAILABILITY_INFO',
    },
    PRODUCT_COMMENT_MODERATION: {
        closeOnRouteChange: true,
        name: 'PRODUCT_COMMENT_MODERATION',
    },
    PRODUCT_DELIVERY: {
        closeOnRouteChange: true,
        name: 'PRODUCT_DELIVERY',
    },
    PRODUCT_NOTIFY_AVAILABLE: {
        closeOnRouteChange: true,
        name: 'PRODUCT_NOTIFY_AVAILABLE',
    },
    PRODUCT_PICKUP: {
        closeOnRouteChange: true,
        name: 'PRODUCT_PICKUP',
    },
    PRODUCT_PRICE: {
        closeOnRouteChange: true,
        name: 'PRODUCT_PRICE',
    },
    PRODUCT_RATING: {
        closeOnRouteChange: true,
        name: 'PRODUCT_RATING',
    },
    PRODUCT_RESERVE: {
        closeOnRouteChange: true,
        name: 'PRODUCT_RESERVE',
    },
    PRODUCT_SET: {
        closeOnRouteChange: true,
        name: 'PRODUCT_SET',
    },
    PRODUCT_SHOP: {
        closeOnRouteChange: true,
        name: 'PRODUCT_SHOP',
    },
    PRODUCT_SUBSCRIPTION: {
        closeOnRouteChange: true,
        name: 'PRODUCT_SUBSCRIPTION',
    },
    PRODUCT_SUBSCRIPTION_AUTH: {
        closeOnRouteChange: true,
        name: 'PRODUCT_SUBSCRIPTION_AUTH',
    },
    PRODUCT_SUBSCRIPTION_CONF_SENT: {
        closeOnRouteChange: true,
        name: 'PRODUCT_SUBSCRIPTION_CONF_SENT',
    },
    RECOVERY_PASSWORD_BY_EMAIL: {
        closeOnRouteChange: true,
        name: 'RECOVERY_PASSWORD_BY_EMAIL',
    },
    REGISTER_TO_TASTING_MODAL: {
        closeOnRouteChange: true,
        name: 'REGISTER_TO_TASTING_MODAL',
    },
    SEARCH_MOBILE: {
        closeOnRouteChange: true,
        name: 'SEARCH_MOBILE',
    },
    SELECT_WINERY_MODAL: {
        closeOnRouteChange: true,
        name: 'SELECT_WINERY_MODAL',
    },
    SNIPPET_PRODUCT_PICKUP: {
        closeOnRouteChange: true,
        name: 'SNIPPET_PRODUCT_PICKUP',
    },
    SNIPPET_PRODUCT_RESERVE: {
        closeOnRouteChange: true,
        name: 'SNIPPET_PRODUCT_RESERVE',
    },
    SHIELD: {
        closeOnRouteChange: true,
        name: 'SHIELD',
    },
    SHOP_LIST: {
        closeOnRouteChange: true,
        name: 'SHOP_LIST',
    },
    SMS_REGISTRATION: {
        closeOnRouteChange: true,
        name: 'SMS_REGISTRATION',
    },
    STOCK_X_MODAL: {
        closeOnRouteChange: true,
        name: 'STOCK_X_MODAL',
    },
    STOCK_X_TERMS_MODAL: {
        closeOnRouteChange: true,
        name: 'STOCK_X_TERMS_MODAL',
    },
    SUBSCRIPTION_DIALOG: {
        closeOnRouteChange: true,
        name: 'SUBSCRIPTION_DIALOG',
    },
    SUPPORT_REDIRECT: {
        closeOnRouteChange: true,
        name: 'SUPPORT_REDIRECT',
    },
    TASTING_CERTIFICATE_INFO: {
        closeOnRouteChange: true,
        name: 'TASTING_CERTIFICATE_INFO',
    },
    TASTING_VIDEO: {
        closeOnRouteChange: true,
        name: 'TASTING_VIDEO',
    },
    TOOLTIP_MODAL: {
        closeOnRouteChange: true,
        name: 'TOOLTIP_MODAL',
    },
    TOP_FILTER_MODAL_MOBILE: {
        closeOnRouteChange: false,
        name: 'TOP_FILTER_MODAL_MOBILE',
    },
    USER_ALREADY_REGISTERED: {
        closeOnRouteChange: true,
        name: 'USER_ALREADY_REGISTERED',
    },
    USER_BLOCKED: {
        closeOnRouteChange: true,
        name: 'USER_BLOCKED',
    },
    USER_DOES_NOT_EXIST: {
        closeOnRouteChange: true,
        name: 'USER_DOES_NOT_EXIST',
    },
    WISH_LIST_MODAL: {
        closeOnRouteChange: true,
        name: 'WISH_LIST_MODAL',
    },
    PRODUCT_VIDEO_MODAL: {
        closeOnRouteChange: true,
        name: 'PRODUCT_VIDEO_MODAL',
    },
    PRIVE_BONUSES_MODAL: {
        closeOnRouteChange: true,
        name: 'PRIVE_BONUSES_MODAL',
    },
    WISHLIST_CLEAR_CONFIRMATION: {
        closeOnRouteChange: true,
        name: 'WISHLIST_CLEAR_CONFIRMATION',
    },
    PRODUCT_YASPLIT_MODAL: {
        closeOnRouteChange: true,
        name: 'PRODUCT_YASPLIT_MODAL',
    },
    PRODUCT_LOYALTY_RESTRICTION_MODAL: {
        closeOnRouteChange: true,
        name: 'PRODUCT_LOYALTY_RESTRICTION_MODAL',
    },
    PRODUCT_GROWING_DISCOUNT_MODAL: {
        closeOnRouteChange: true,
        name: 'PRODUCT_GROWING_DISCOUNT_MODAL',
    },
    PROFILE_PHONE_SMS: {
        closeOnRouteChange: true,
        name: 'PROFILE_PHONE_SMS',
    },
    BONUS_HISTORY: {
        closeOnRouteChange: true,
        name: 'BONUS_HISTORY',
    },
    MANAGER_MODAL: {
        closeOnRouteChange: true,
        name: 'MANAGER_MODAL',
    },
    NEW_OFFER_REQUEST: {
        closeOnRouteChange: true,
        name: 'NEW_OFFER_REQUEST',
    },
    PROMOCODE_TERMS_MODAL: {
        closeOnRouteChange: true,
        name: 'PROMOCODE_TERMS_MODAL',
    },
} as const;
